/**
* About
*
* namespace
* run dom ready
* fire functions
*/

/**
* About namespace
* @type {Object}
*/
SDG.About = SDG.About || {};

/**
* run dom ready
* @type {Function}
*/
SDG.About.run = function() {
	var videoEmbed = SDG.videoEmbed('lhk-video'),
    	button = 'readMoreTrigger',
		slideDown = document.getElementById('readMoreText');

	// init functions
	videoEmbed.init();

	_.scrollTo({
		id   : 'scroll-to',
		offset : -50
     });

	 document.getElementById(button).addEventListener('click', function( e ) {
		 _.slideDown(slideDown);
	 });

  	require([path.flickity], function(Flickity){
        SDG.About.lhkGallery(Flickity);
    });

	 SDG.About.videoModal();
};

SDG.About.videoModal = function() {

	function init() {

		SDG.videoEmbed({
			id: 'lhk-video',
			show_in_modal : true,
			modal: {
				modal_id: 'aboutModal',
				overlay: 'aboutModalOverlay',
				trigger: 'aboutModalVideoTrigger',
				modifier: 'about'

			}
		}).init();
	}

	return init();
};

SDG.About.lhkGallery = function(Flickity) {

	var mainSlide,
		images = '#lhk-gallery',

	mainSlide = new Flickity(images, {
		// options
		contain: true,
		prevNextButtons: true,
		adaptiveHeight: true,
		pageDots: true,
		accessibility: false,
      	wrapAround: true,
        arrowShape:'M34.62 29.927c-3.582.314-3.21-.208-8.03.057-.565.102-.984.161-1.353.201.825 1.008 1.637 2.027 2.362 3.116 1.799 2.706-2.46 5.243-4.243 2.563-1.82-2.738-4.201-5.017-5.935-7.83-.915-1.484-.115-2.895 1.083-3.47l.004-.004c2.619-1.925 4.853-4.344 7.573-6.136 2.679-1.766 5.14 2.631 2.478 4.385-1.123.739-2.165 1.592-3.188 2.471.946.06 2.083.014 4.049-.22 3.235-.221 4.279 0 5.2-.212 3.164.049 3.169 5.127 0 5.079z',
	});
	window.lhkgallery = mainSlide;
};


SDG.About.scroll = function() {
	var URL = document.URL,
		hash = '',
		targetId = 'our-organic-farm',
		founderId = 'meet-our-founder',
		getHashTag = function(url) {
		   hash = url.split('#')[1];
		   return hash;
	    };

   if (getHashTag(URL) === targetId) {
	   _.scrollTo({
		   exec_now: true,
		   target : targetId
	   });
   }

   if (getHashTag(URL) === founderId) {
	   _.scrollTo({
		   exec_now: true,
		   target : founderId
	   });
   }

};

SDG.About.runDomReady = function() {

	_.ready(function() {
		SDG.About.scroll();
	});

};

/**
* fire functions
*/


SDG.About.run();
SDG.About.runDomReady();